export const VALIDATION_TYPES = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
}
export const PRIORITY_LEVELS = {
  BASE: 0,
  MIDDLE: 1,
  TOP: 2,
}

export const FIELDS = {
  ADDRESS: 'address',
  AMOUNT: 'amount',
  MEMO: 'memo',
}

// TODO move each custom validation to its plugin
export const CAN_SEND_ZERO_AMOUNT = ['algorand']
export const ASSETS_WITHOUT_SELF_SEND = ['eosio', 'hedera', 'ripple', 'tronmainnet']
